// Custom VFG components

<template>
    <div class="wrapper field-input"> 
        <input 
            class="form-control"
            type="radio"
            @blur="triggerValidation"
            v-model="value" 
            :disabled="disabled"
            :maxlength="schema.max"
            :placeholder="schema.placeholder"
            :readonly="schema.readonly" >
    </div>
</template> 

<script>
    export default {
        props: ['text'],
        name: 'fv_radio',
        mixins: [ VueFormGenerator.abstractField],
        methods: {
            triggerValidation() {
                this.validate();
                return true
            }
        }
        ,
        data() {
            return {} 
        }
        } 
</script>

<style>

</style>

                            
